
import { createContext, ReactNode } from 'react';
import { IContainer } from './interface/container';
import { bind as bindConfig } from './config/bind';
import { bind as bindUtil } from './util/bind';
import { bind as bindRouter } from './routes/bind';
import { bind as bindState } from './state/bind';
import { bind as bindWorker } from './worker/bind';
const bindMediaPlayer = () => Promise.resolve(); /* placeholder, including path results in files bundled into static/js/main*.js increasing initial bundle size */

const IOCContext = createContext<IContainer|null>(null);

export interface IIOCContainerProps {
    container: IContainer;
    children?: ReactNode;
};

export interface IContainerPrv extends IContainer {
    _map: Map<symbol, any>;
}

export function Container(): IContainer {
    const container: IContainerPrv = {
        _map: new Map(),
        get: function<T>(this: IContainerPrv, key: symbol): T {
            return this._map.get(key) as T;
        },
        bind: function(this: IContainerPrv, key: symbol, value: any) {
            this._map.set(key, value);
        },
    };

    return container as IContainer;
}

export function IOCContainer(props: IIOCContainerProps): JSX.Element {
    const ProviderIOC = IOCContext.Provider;
    return (
        <ProviderIOC value={props.container}>
            {props.children}
        </ProviderIOC>
    );
};

export function bindAll(container: IContainer): Promise<void> {
    return new Promise(async function(resolve, reject) {
        try {
            const binders: Array<(container: IContainer) => Promise<void>> = [bindUtil, bindConfig, bindRouter, bindState, bindWorker, bindMediaPlayer];

            for ( const binder of binders ) {
                await binder(container);
            }

            resolve();
        } catch (error) {
            console.error(`bind failed: ${JSON.stringify(error)}`);
            reject(error);
        }
    });
}
